import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NavigationBar = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className="w-full fixed top-10 left-0 z-50 bg-transparent">
            <nav className={`w-full max-w-[1320px] mx-auto flex justify-between items-center px-5 py-3 border border-neutral-500 border-opacity-30 rounded-md bg-white transition-all duration-300 ${isScrolled ? "shadow-md" : ""}`}>
                <div className="flex items-center">
                    <Link to="/">
                        <h1 className="text-2xl font-bold">iExcel International English</h1>
                    </Link>
                </div>

                <div className="flex items-center max-md:gap-2.5 max-sm:hidden">
                    <Link to="/about" className="px-5 py-4 text-base leading-6 text-black cursor-pointer hover:text-orange-500">About Us</Link>
                    <Link to="/programs" className="px-5 py-4 text-base leading-6 text-black cursor-pointer hover:text-orange-500">Programs</Link>
                    <Link to="/contact" className="px-5 py-4 text-base leading-6 text-black cursor-pointer hover:text-orange-500">Contact</Link>
                </div>

                <Link to="/programs">
                    <button className="px-6 py-3.5 text-base leading-6 text-white bg-orange-500 hover:bg-orange-400 rounded border border-orange-500 border-solid shadow-sm cursor-pointer max-sm:px-4 max-sm:py-2.5 max-sm:text-sm">
                        Explore Programs
                    </button>
                </Link>
            </nav>
        </header>
    );
};

export default NavigationBar;
